// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app {
  margin: 50px auto 0;
  display: flex;
  flex-direction: column;
  gap: 50px;
  padding: 3rem;
  border: 2px solid darkgray;
  width: 50%;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  transform: translateZ(0);
}
h1.app-heading {
  display: flex;
  gap: 3rem;
  font-size: 3em;
  align-items: center;
  overflow: hidden;
}

.app-loading {
  font-size: 3em;
  display: grid;
  place-items: center;
  height: 100vh;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,0BAA0B;EAC1B,UAAU;EACV,uBAAuB;EACvB,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,SAAS;EACT,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf","sourcesContent":[".app {\n  margin: 50px auto 0;\n  display: flex;\n  flex-direction: column;\n  gap: 50px;\n  padding: 3rem;\n  border: 2px solid darkgray;\n  width: 50%;\n  justify-content: center;\n  align-items: center;\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);\n  border-radius: 10px;\n  transform: translateZ(0);\n}\nh1.app-heading {\n  display: flex;\n  gap: 3rem;\n  font-size: 3em;\n  align-items: center;\n  overflow: hidden;\n}\n\n.app-loading {\n  font-size: 3em;\n  display: grid;\n  place-items: center;\n  height: 100vh;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
